import { AuthLocaleTypes } from '../locales.types'

const authLocaleNn: AuthLocaleTypes = {
  login: 'Logg inn',
  logout: 'Logg ut',
  signup: 'Registrer deg',
  signout: 'Logg ut',
  withFeide: 'Logg inn med Feide',
  email: 'E-post',
  emailPlaceholder: 'eksempel@epost.com',
  password: 'Passord'
}

export default authLocaleNn
